export const featureOptionNamesValidator = (
	options: {
		name: string
	}[]
) => {
	const allOptionNames = options.map(option => option.name)

	return Array.from(new Set(allOptionNames)).length === allOptionNames.length
}
